import { createApp } from 'vue';
import App from './App'
import router from './router'
import store from './store'
import api from "@/services";
import device from 'current-device';
import moment from 'moment';

//js
import "./assets/js/jquery-1.8.3.min.js";

//css
import "./assets/styles/phone.scss";
import "./assets/styles/global.scss";
import "./assets/styles/animation.scss";

const app = createApp(App);

app.config.productionTip = false;
app.config.globalProperties.$api = api;
app.use(router).use(store);

//ant
import 'ant-design-vue/dist/antd.less';
import {
    Button, Dropdown, Menu, Spin, Tooltip, Input, Popconfirm, ConfigProvider, Empty, Checkbox, Modal, Alert,
    Table, Select, Breadcrumb, Pagination, Image, InputNumber, Form, Radio, notification, message, Progress,
    Slider,Switch
} from 'ant-design-vue'


app.use(Button).use(Dropdown).use(Menu).use(Spin).use(Tooltip).use(Input).use(Popconfirm).use(ConfigProvider)
    .use(Empty).use(Checkbox).use(Modal).use(Alert).use(Table).use(Select).use(Breadcrumb).use(Pagination).use(Progress)
    .use(Image).use(InputNumber).use(Form).use(Radio).use(Slider).use(Switch);

message.config({
    duration: 2,
    maxCount: 1,
    key: 1
})

app.config.globalProperties.$notification = notification;
app.config.globalProperties.$message = message;
app.config.globalProperties.$moment = moment;
app.config.globalProperties.$device = device;
app.config.globalProperties.$nzconfirm = function confirm(title, callback) {
    Modal.confirm({
        okText: '确认',
        cancelText: '取消',
        title: title,
        onOk: () => {
            return callback();
        }
    })
}

app.directive('focus', {
    mounted(el) {
        el.focus();
        const inputElement = el.querySelector('input');
        if (inputElement && !inputElement.value) {
            inputElement.focus();
        }
    }
});
app.mount('#app')